import React from 'react';
import {Provider} from 'react-redux';
import {Router} from 'react-router';

import {
  NoPermissionModal,
  InformationModal,
  CsvExportModal,
  XlsxExportModal
} from 'components/CommonModals';
import Toaster from 'components/Toaster';

const Root = ({store, history, Routes}) => {
  return (
    <Provider store={store}>
      <React.Fragment>
        <Router history={history}>
          <Routes />
        </Router>
        <NoPermissionModal />
        <InformationModal />
        <CsvExportModal />
        <XlsxExportModal />
        <Toaster />
      </React.Fragment>
    </Provider>
  );
};

export default Root;
